import React, { useEffect, useState, useRef } from 'react';
import { FaPlus, FaEdit, FaTrashAlt, FaMapMarkerAlt } from "react-icons/fa";
import { FaShieldHalved, FaCodeBranch } from "react-icons/fa6";

import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import Sidebar from '../../includes/Sidebar';
import { Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { getAddressList, RemoveAddress, setDefaultAddress } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import AddAddress from '../../components/AddAddress/AddAddress';
import Alert from 'react-bootstrap/Alert';
import { useNavigate, Link } from "react-router-dom";

const ManageAddresses = () => {
    const ardRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [ismsg, setisMsg] = useState(false);
    const [msg, setMsg] = useState('');
    const [editAddress, setEditAddress] = useState(null);
    const [ids, setIds] = useState(null);
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    const getAddressLists = async () => {
        try {
            const res = await getAddressList();
            setData(res.data.data);
            setLoading(false);
            setisMsg(false);
        } catch (error) {
            setLoading(false);
            setisMsg(true);
            setMsg(error.response.data.message);
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('userToken')) {
            navigate("/");
        }
        else {
            getAddressLists();
        }
    }, [])

    const handleSetDefault = async (id) => {
        setLoadings(true);
        try {
            const res = await setDefaultAddress(id);
            //toast.success(res.data.message);
            getAddressLists();
            setLoadings(false);
        } catch (error) {
            console.log(error);
            setLoadings(false);
        }
    };

    const handleRemove = async (id) => {
        setShow(false);
        setLoadings(true);
        try {
            const res = await RemoveAddress(id);
            //(res.data.message);
            getAddressLists();
            setLoadings(false);
        } catch (error) {
            console.log(error);
            setLoadings(false);
        }
    };

    const hendelCancel = () => {
        setIsVisible(false);
        setEditAddress(null)
    };

    const handleScroll = () => {
        if (ardRef.current) {
            ardRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <>
            <Header toast={toast} />
            <ToastContainer />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <Link to={'/profile'}>My Account</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">Manage Addresses</span>
                        </div>
                    </div>

                    <section className="page-hero cart-hero">
                        <Container>
                            <div className="page-wrap hero-inner">
                                <div className="hero-title">
                                    <span className="hero-icon"><FaMapMarkerAlt style={{ color: '#00a99d' }} /></span>
                                    <div>
                                        <h1>Manage Addresses</h1>
                                        <p>Complete your order and enjoy premium protection.</p>
                                    </div>
                                </div>
                                <div className="hero-perks">
                                    <div className="hero-perk"><FaShieldHalved /><span><b>1-Year Warranty</b>on Premium Products</span></div>
                                    <div className="hero-perk"><FaCodeBranch /><span><b>2 Free Replacements</b>on Premium Shield</span></div>
                                    <div className="hero-perk"><FaShieldHalved /><span><b>Secure Checkout</b>100% Safe &amp; Trusted</span></div>
                                </div>
                            </div>
                        </Container>
                    </section>



                    <main className="main" style={{ paddingBottom: '50px' }}>
                        <Container>
                            <div className="layout">
                                <Sidebar />
                                <section className="content">
                                    <div className='titles-box'>
                                        <button className='btn btn-green' onClick={() => setIsVisible(!isVisible)}><FaPlus /> Add New</button>
                                    </div>
                                    {isVisible ?
                                        <div className='cards'>
                                            <AddAddress
                                                toast={toast}
                                                hendelCancel={hendelCancel}
                                                getAddressLists={getAddressLists}
                                                editAddress={editAddress}
                                            />
                                        </div> : null
                                    }
                                    {ismsg ? (
                                        <div className='nodata'>
                                            <p>{msg}</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className='addresscards'>
                                                {isLoading ? <Loader /> : (<>
                                                    {data.map((item) => (
                                                        <div key={item.id} className='cards'>
                                                            {item.is_default === 1 ?
                                                                <div className='isdefalut'>Default Address</div> : null}
                                                            <div className='add_hed'>
                                                                <h6>{`${item.first_name} ${item.last_name}`}&nbsp;&nbsp;&nbsp;{item.mobile_no}</h6>
                                                                <div className='btns'>
                                                                    <button onClick={() => { setIsVisible(true); setEditAddress(item); handleScroll(); }}>
                                                                        <FaEdit />
                                                                    </button>
                                                                    <button onClick={() => { setShow(true); setIds(item.id); }}>
                                                                        <FaTrashAlt />
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            <p>{`${item.address_line1} ${item.address_line2} ${item.landmark} ${item.city}, ${item.state.name}`}
                                                                <b> - {item.postal_code}</b>
                                                            </p>
                                                            {item.is_default === 0 ? <button className='btn btn-link' onClick={() => handleSetDefault(item.id)}>set as Default Address</button> : null}
                                                        </div>
                                                    ))}
                                                </>)}
                                            </div>
                                        </>
                                    )}
                                </section>
                            </div>
                        </Container>
                    </main>
                </>
            )}



            <Footer toast={toast} />

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure Delete this Address?</Alert.Heading>
                    <hr />
                    <div className='buttons'>
                        <div>
                            <button onClick={() => handleRemove(ids)} className='btn btn-green'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-red'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default ManageAddresses;